
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zahlung-und-versand",
      function () {
        return require("private-next-pages/zahlung-und-versand.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zahlung-und-versand"])
      });
    }
  